module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-192x192-a7254c673d33e137c9fa0300f5221554.png";